import { render, staticRenderFns } from "./GoogleLogin2.vue?vue&type=template&id=31652e5c"
import script from "./GoogleLogin2.vue?vue&type=script&lang=js"
export * from "./GoogleLogin2.vue?vue&type=script&lang=js"
import style0 from "./GoogleLogin2.vue?vue&type=style&index=0&id=31652e5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports